import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import $session from "servicestack/session";
import shoppingConfig from "emun.shopping/shopping.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import ServiceBus from "servicestack/service-bus";
const types = ["question", "incident", "problem", "task"];
const priorities = ["low", "normal", "high", "urgent"];
import Product from "emun.shopping/product.model";
import _ from "underscore";
import modals from 'webmodals/modals'

const productSorter = scan => (a, b) => {
	const aI = a.id.indexOf(scan);
	const bI = b.id.indexOf(scan);
	if (aI === -1 && bI >= 0) return 1;
	if (bI === -1 && aI >= 0) return -1;
	if (aI >= 0 && bI >= 0 && aI > bI) return 1;
	if (aI >= 0 && bI >= 0 && bI > aI) return -1;
	if (bI === aI && aI >= 0) {
		const skuComp = skuLengthSorter(a, b);
		if (skuComp !== 0) return skuComp;
		return availableQtySorter(a, b);
	}
	return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
	if (a.id.length > b.id.length) return 1;
	if (b.id.length > a.id.length) return -1;
	return 0;
};
const availableQtySorter = (a, b) => {
	if (a.availableQty > b.availableQty) return -1;
	if (b.availableQty > a.availableQty) return 1;
	return 0;
};

export default class TicketController {
	constructor($geo) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.types = types;
		$ctrl.priorities = priorities;
		$ctrl.today = new Date().getTime();
		$ctrl.labels = labels;
		$ctrl.$geo = $geo;
		$ctrl.bus = new ServiceBus();
		$ctrl.prodQuery = new AutoQuery({
			url: "QueryProducts.json?V=Scan&IncludeInactive=1",
			autoLoad: false,
			criteria: {
				//CategoryId: 'FAN'
			},
			pageSize: 48,
			scrub: res =>
				(res.data.results = Product.map(
					res.data.results.sort(productSorter($ctrl.prodQuery.criteria.scan))
				)),
			onLoaded: args => $ctrl.productsLoaded(args)
		});
	}

	$onInit() {
		const $ctrl = this;
		$ctrl.bus.send("GetTicketFields.json").then(function (res) {
			$ctrl.ticketFields = _.indexBy(res.data.ticket_fields, 'title');
			if ($ctrl.ticketId) {
				$ctrl.bus.send("GetTicket.json?Id=" + $ctrl.ticketId).then(function (res) {
					$ctrl.ticket = res.data.ticket;
					//$ctrl.prodQuery.criteria.scan = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value;
					if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value) {
						$ctrl.getEmunOrder($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value);
					}
				});
			} else {
				$ctrl.loadTickets();
			}
		});
	}

	loadTickets() {
		const $ctrl = this;
		$ctrl.bus
			.send("GetTickets.json?Status=Open&assigned_email=" + $ctrl.$session.email)
			.then(function (res) {
				$ctrl.tickets = res.data.results;
				if ($ctrl.ticketId) {
					var tickets = $ctrl.tickets.filter(function (t) {
						return t.id.toString().indexOf($ctrl.ticketId) > -1;
					});
					if (tickets.length > 0) {
						$ctrl.ticket = tickets[0];
						$ctrl.prodQuery.criteria.scan = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value;
						if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value) {
							$ctrl.getEmunOrder($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value);
						}
					}
				} else {
					$ctrl.ticket = {
						status: 'Open',
						custom_fields: [],
						assignee_email: $ctrl.$session.email
					};

					$ctrl.ticketFields.forEach(function (f) {
						$ctrl.ticket.custom_fields.push({
							id: f.id,
							value: ''
						});
					});
				}
			});
	}
	findTickets(val) {
		const $ctrl = this;
		return $ctrl.tickets.filter(function (t) {
			return t.id.toString().indexOf(val) > -1;
		});
	}

	resetForm() {
		const $ctrl = this;
		$ctrl.selectedTransType = "";
		$ctrl.selectedProductType = "";
		$ctrl.selectedShippingType = "";
		$ctrl.selectedDefective = "";
		$ctrl.selectedWarranty = "";
		$ctrl.transType = "";
		$ctrl.orderType = "";
		$ctrl.productType = "";
		$ctrl.shippingType = "";
		$ctrl.purchaseAccount = "";
		$ctrl.stopMessage = "";
		$ctrl.defective = "";
		$ctrl.warranty = "";
		$ctrl.selectedPurchasedFrom = "";
		$ctrl.purchasedFrom = "";
	}
	canStartOrder() {
		const $ctrl = this;
		if ($ctrl.ticket && $ctrl.transType && (!$ctrl.order || $ctrl.order.status == 'Cart')) {
			if ($ctrl.transType == "purchase") {
				if ($ctrl.shippingType && $ctrl.purchaseAccount) {
					$ctrl.orderType = "Purchase";
					return true;
				} else {
					return false;
				}
			} else if ($ctrl.transType == "warranty") {
				$ctrl.orderType = "Warranty";
				return true;
			} else if ($ctrl.transType == "refund") {
				if ($ctrl.purchasedFrom == "phone") {
					$ctrl.orderType = "Refund";
					return true;
				} else if ($ctrl.purchasedFrom == "hunter") {
					$ctrl.stopMessage = "Send consumer to website to start return process";
					return false;
				} else if ($ctrl.purchasedFrom == "other") {
					$ctrl.stopMessage = "Instruct consumer to return to store";
					return false;
				}
			}
		} else {
			return false;
		}
		return false;
	}

	getEmunOrder(orderNumber) {
		const $ctrl = this;
		$ctrl.order = {};
		$ctrl.bus.send("QueryCarts.json?Id=" + orderNumber).then(function (res) {
			if (res.data.results.length > 0) {
				$ctrl.order = res.data.results[0];
				if ($ctrl.order.status == "Cart") {
					$ctrl.resetForm();
				} else {
					$ctrl.orderType = $ctrl.order.reasonCode;
					$ctrl.productType = $ctrl.order.vendorNote;
					$ctrl.shippingType = $ctrl.order.note;
				}
				$ctrl.mediaQuery = new AutoQuery({
					url: 'QueryMedia.json?realm=ShippingLabels',
					tagCriteria: {
						"OrderNumber": $ctrl.order.id
					},
					autoLoad: true,
					onLoaded: function (args) {
						$ctrl.label = args.first;
					}
				});
			}
		});
	}

	selectTicket(val) {
		const $ctrl = this;
		var ticketChanged = false;
		if ($ctrl.ticket.id != val.id) ticketChanged = true;

		console.debug("selectTicket: ", val);
		$ctrl.ticket = val;
		if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value) {
			$ctrl.prodQuery.criteria.scan = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value;
			if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value) {
				$ctrl.getEmunOrder($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value);
			} else {
				$ctrl.resetForm();
			}
		}
	}

	getFieldByTitle(title) {
		const $ctrl = this;
		var index = $ctrl.getFieldIndex($ctrl.ticketFields[title].id);
		return index;
	}
	getFieldIndex(id) {
		const $ctrl = this;
		var fieldIndex = -1;
		$ctrl.ticket.custom_fields.forEach(function (c, index) {
			if (c.id == id) {
				fieldIndex = index;
			}
		});
		return fieldIndex;
	}

	updateTicket(gotoOrder) {
		const $ctrl = this;
		$ctrl.ticket.CustomFields = $ctrl.ticket.custom_fields;
		$ctrl.bus.send('UpdateTicket.json', $ctrl.ticket).then(function (res) {
			$ctrl.fillOrderFromTicket();
			$ctrl.bus.send('UpdateCart.json', $ctrl.order).then(function (res) {
				if (gotoOrder) {
					$ctrl.$state.go("ticket-order", { orderId: $ctrl.order.id });
				}
			}, function (res) {
				$ctrl.resetForm();
			});
		}, function (res) {
			modals.alert(res.data.responseStatus.message);
		});
	}

	fillOrderFromTicket() {
		const $ctrl = this;
		$ctrl.order.reasonCode = $ctrl.orderType;
		$ctrl.order.type = $ctrl.orderType;
		$ctrl.order.vendorNote = $ctrl.productType;
		$ctrl.order.note = $ctrl.shippingType;
		$ctrl.order.tagFor = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value
		$ctrl.order.purchaser.email = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Email')].value;
		$ctrl.order.email = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Email')].value;
		$ctrl.order.shippingLocation = {
			companyName: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Customer Name')].value,
			address: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Address')].value,
			city: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('City')].value,
			state: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('State')].value,
			zip: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Zip')].value,
			country: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value,
			phone: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Phone')].value,
			email: $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Email')].value
		};
	}
	loadProducts() {
		const $ctrl = this;
		if (($ctrl.prodQuery.criteria.scan || "").length >= 3) {
			$ctrl.$selectedIndex = null;
			//$ctrl.product = null;
			$ctrl.prodQuery.load(true);
		} else {
			$ctrl.products = [];
		}
	}
	getProduct(id) {
		const $ctrl = this;
		if (id) {
			console.info("getProduct", id);
			$ctrl.prodQuery.bus.cancelAll();
			$ctrl.prodQuery.bus
				.read("QueryProducts.json", {
					cartId: $ctrl.$cart.cartId,
					id
				})
				.then(res => {
					if (res.data.results.length > 0) {
						$ctrl.setProduct(new Product(res.data.results[0]));
					}
				});
		}
	}

	productsLoaded(args) {
		const $ctrl = this;
		$ctrl.products = args.results;
		//$ctrl.product = null;
		$ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;
		if (
			args.results.length === 1 &&
			$ctrl.products[0].id === $ctrl.prodQuery.criteria.scan
		) {
			$ctrl.setProduct(args.first);
		} else if (args.results.length == 0) {
			$ctrl.invalid = true;
		} else {
			$ctrl.$selectedIndex = 0;
		}
	}

	setProduct(p) {
		const $ctrl = this;
		console.info("setProduct", p);
		$ctrl.products = [];
		$ctrl.$selectedIndex = null;
		$ctrl.invalid = false;
		$ctrl.product = p;
		if ($ctrl.$cart.reasonCode === "Warranty") {
			$ctrl.product.price = 0;
		}
		$ctrl.bus.send("GetAvailability.json", { ProductIds: $ctrl.product.id }).then(function (response) {
			if (response.data.products) {
				$ctrl.product.availableQty = response.data.products[0].quantityAvailable;
				var availDate = response.data.products[0].estimatedAvailableDate;
				if (availDate !== "") {
					$ctrl.product.availableOn = availDate.substring(4, 6) + "/" + availDate.substring(6, 8) + "/" + availDate.substring(0, 4);
				}
			} else {
				$ctrl.product.availableQty = "X";
			}
//			$ctrl.product.canAdd = $ctrl.canAdd($ctrl.product);
		});
		$ctrl.quantity = $ctrl.product.minimumOrderQty || 1;
		$ctrl.product.qtyIncrement = $ctrl.product.purchaseIncrement || 1;
		$ctrl.product.shipDate = $ctrl.$cart.shipOn;
		$ctrl.prodQuery.criteria.scan = "";
		$ctrl.parts = [];
		if ($ctrl.product.parts) {
			$ctrl.productIds = $ctrl.product.parts.map(part => part.ProductId);
			if ($ctrl.productIds != "") {
				$ctrl.partsQuery = new AutoQuery({
					url: 'QueryProducts.json',
					criteria: {
						IncludeInactive: true,
						cartId: $ctrl.$cart.cartId,
						IdIn: $ctrl.productIds
					},
					orderBy: 'Id',
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function (args) {
						$ctrl.parts = args.results = Product.map(
							args.results
						);
						if ($ctrl.$cart.reasonCode == "Warranty") {
							$ctrl.parts.forEach(function (p) {
								p.price = 0;
								p.availableQty = "X";
							});
						}
						$ctrl.parts.forEach(function (p) {
							$ctrl.bus.send("GetAvailability.json", { ProductIds: p.id }).then(function (response) {
								if (response.data.products) {
									p.availableQty = response.data.products[0].quantityAvailable;
									var availDate = response.data.products[0].estimatedAvailableDate;
									if (availDate !== "") {
										p.availableOn = availDate.substring(4, 6) + "/" + availDate.substring(6, 8) + "/" + availDate.substring(0, 4);
									}
								} else {
									p.availableQty = "X";
								}
//								p.canAdd = $ctrl.canAdd(p);
							});
						});
					}
				});
			}
		}
		if (($ctrl.product.meta["Status"] == "OB2" || $ctrl.product.meta["Status"] == "DIS" || $ctrl.product.meta["Status"] == "NFS") && $ctrl.product.onDemandProductEuid) {
			//modals.alert("The model you have entered has been replaced by " + $ctrl.product.onDemandProductEuid + ".  Please update your records for future reference");
			//$ctrl.getProduct($ctrl.product.onDemandProductEuid);
      $ctrl.product.hasReplacement = true;
		} else if ($ctrl.product.meta["Status"] == "OB2") {
			modals.alert("The model you have entered is obsolete");
			$ctrl.product = {};
		}
	}

  replacement() {
    const $ctrl = this;
    $ctrl.getProduct($ctrl.product.onDemandProductEuid);
  }

	gotoOrder() {
		const $ctrl = this;
		$ctrl.updateTicket(true);
	}
	startOrder() {
		const $ctrl = this;
		//console.info("BL*** in startOrder");
		if (!$ctrl.canStartOrder()) { return; }
		//if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == "US" && !$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('State')].value) {
		//	$ctrl.bus.validationErrors = [];
		//	$ctrl.bus.validationErrors.push([{
		//		errorCode: "-1",
		//		fieldName: "address",
		//		message: "State must be populated"
		//	}]);
		//	return;
		//}

		//if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == "US" && !$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Zip')].value) {
		//	$ctrl.bus.validationErrors = [];
		//	$ctrl.bus.validationErrors.push([{
		//		errorCode: "-1",
		//		fieldName: "address",
		//		message: "Zip must be populated"
		//	}]);
		//	return;
		//}
		$ctrl.order = {
			status: "Cart",
			purchaseOrder: $ctrl.ticket.id,
			businessModel: "Wholesale",
			dropShip: true,
			reasonCode: $ctrl.orderType,
			vendorNote: $ctrl.productType,
			note: $ctrl.shippingType || 'usa',
			type: $ctrl.orderType,
			paymentTermsId: $ctrl.orderType == 'Warranty' || $ctrl.orderType == 'Refund' ? 'J' : 'C03'
		};
		$ctrl.bus.send('QueryRetailers.json', { Id: $ctrl.orderType == 'Warranty' ? '3000786' : $ctrl.orderType == 'Purchase' ? $ctrl.purchaseAccount : '384596' }).then(function (response) {
			if (response.data.total > 0) {
				var result = response.data.results[0];
				$ctrl.order.purchaser = {
					id: result.id,
					companyName: result.companyName,
					address: result.address,
					city: result.city,
					state: result.state,
					zip: result.zip,
					country: result.country,
					phone: result.phone,
				};
				$ctrl.fillOrderFromTicket();
				$ctrl.bus.send('CreateCart.json', $ctrl.order).then(function (cart) {
					//$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value = cart.data.id;
					$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Sent to JDE')].value = "No";
					$ctrl.ticket.CustomFields = $ctrl.ticket.custom_fields;
					$ctrl.bus.send($ctrl.ticket.id ? 'UpdateTicket.json' : 'CreateTicket', $ctrl.ticket).then(function (res) {
						cart.data.purchaseOrder = res.data.ticket.id;
						$ctrl.bus.send('UpdateCart.json', cart.data).then(function (res) {
							$ctrl.$state.go("ticket-order", { orderId: cart.data.id });
						});
					}, function (res) {
						modals.alert(res.data.responseStatus.message);
					});
				});
			}
		});
	}

}
